import { render } from "./basicServices.vue?vue&type=template&id=2a4c29d0&scoped=true"
import script from "./basicServices.vue?vue&type=script&lang=js"
export * from "./basicServices.vue?vue&type=script&lang=js"

import "./basicServices.vue?vue&type=style&index=0&id=2a4c29d0&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4c29d0"]])

export default __exports__